/**
 * Build a schema.org FAQPage JSON-LD object from Q/A pairs.
 * Pass the resulting object alongside your Article/BlogPosting JSON-LD.
 *
 * Google guidelines: only include FAQs actually visible on the page.
 */
export interface FaqQA {
  question: string;
  answer: string;
}

export const buildFaqLd = (faqs: FaqQA[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(({ question, answer }) => ({
    "@type": "Question",
    name: question,
    acceptedAnswer: {
      "@type": "Answer",
      text: answer,
    },
  })),
});
